var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "content" } },
    [
      _c("div", { staticClass: "header col-md-12" }, [
        _c("div", { staticClass: "header-inner row align-items-center" }, [
          _c("div", { staticClass: "col left" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("sidebar.goodstransfer")) +
                  " > " +
                  _vm._s(_vm.$t("sidebar.create")) +
                  "\n        "
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content col-md-12" },
        [
          !_vm.ready
            ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
            : _vm._e(),
          _vm._v(" "),
          _vm.ready
            ? [
                _c("section", [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: {
                          title: _vm.$t("message.date"),
                          subtitle: _vm.gtCode
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c(
                              "div",
                              { staticClass: "col-md-12" },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "apps.inventory.message.transferdate"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("BaseInputDatePicker", {
                                  attrs: { mode: "dateTime", is24hr: "" },
                                  model: {
                                    value: _vm.form.selectedDate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "selectedDate", $$v)
                                    },
                                    expression: "form.selectedDate"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ])
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("section", [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: {
                          title: _vm.$t("apps.inventory.message.transfer")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c("div", { staticClass: "form-group form-row" }, [
                            _c("div", { staticClass: "col-md-12" }, [
                              _c("div", { staticClass: "form-row" }, [
                                _c("div", { staticClass: "col-md-6" }, [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "apps.inventory.message.transferfrom"
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.form.pickedWarehouseIdFrom,
                                          expression:
                                            "form.pickedWarehouseIdFrom"
                                        }
                                      ],
                                      staticClass: "form-control custom-select",
                                      class: _vm.validate.pickedWarehouseIdFrom,
                                      on: {
                                        change: [
                                          function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.$set(
                                              _vm.form,
                                              "pickedWarehouseIdFrom",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                          _vm.handleChangeWhIdFrom
                                        ]
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        { domProps: { value: null } },
                                        [
                                          _vm._v(
                                            "\n                          " +
                                              _vm._s(
                                                _vm.$t("placeholder.select")
                                              ) +
                                              "\n                        "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(_vm.warehouses, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "option",
                                          {
                                            key: index,
                                            domProps: {
                                              value: item.warehouse_id
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(item.warehouse_name) +
                                                "\n                        "
                                            )
                                          ]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.optionFromBinLocations.length > 1
                                  ? _c(
                                      "div",
                                      { staticClass: "col-md-6" },
                                      [
                                        _c("label", [_vm._v(" ")]),
                                        _vm._v(" "),
                                        _c("BaseDropdown", {
                                          attrs: {
                                            options: _vm.optionFromBinLocations
                                          },
                                          model: {
                                            value: _vm.form.pickedBinIdFrom,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "pickedBinIdFrom",
                                                $$v
                                              )
                                            },
                                            expression: "form.pickedBinIdFrom"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-12 mt-3" }, [
                              _c("div", { staticClass: "form-row" }, [
                                _c("div", { staticClass: "col-md-6" }, [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "apps.inventory.message.transferto"
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.form.pickedWarehouseIdTo,
                                          expression: "form.pickedWarehouseIdTo"
                                        }
                                      ],
                                      staticClass: "form-control custom-select",
                                      class: _vm.validate.pickedWarehouseIdTo,
                                      on: {
                                        change: [
                                          function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.$set(
                                              _vm.form,
                                              "pickedWarehouseIdTo",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                          _vm.handleChangeWhIdTo
                                        ]
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        { domProps: { value: null } },
                                        [
                                          _vm._v(
                                            "\n                          " +
                                              _vm._s(
                                                _vm.$t("placeholder.select")
                                              ) +
                                              "\n                        "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(_vm.warehouses, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "option",
                                          {
                                            key: index,
                                            domProps: {
                                              value: item.warehouse_id
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(item.warehouse_name) +
                                                "\n                        "
                                            )
                                          ]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.optionToBinLocations.length > 1
                                  ? _c(
                                      "div",
                                      { staticClass: "col-md-6" },
                                      [
                                        _c("label", [_vm._v(" ")]),
                                        _vm._v(" "),
                                        _c("BaseDropdown", {
                                          attrs: {
                                            options: _vm.optionToBinLocations
                                          },
                                          model: {
                                            value: _vm.form.pickedBinIdTo,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "pickedBinIdTo",
                                                $$v
                                              )
                                            },
                                            expression: "form.pickedBinIdTo"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ])
                            ])
                          ])
                        ])
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm.form.pickedWarehouseIdTo
                  ? [
                      _c("section", [
                        _c(
                          "div",
                          { staticClass: "col-md-12 no-padding" },
                          [
                            _c("section-header", {
                              attrs: { title: _vm.$t("message.orderlist") }
                            }),
                            _vm._v(" "),
                            _vm.isRenderOrders
                              ? _c("OrderGT", {
                                  attrs: {
                                    validation: _vm.form.trickValidation,
                                    data: _vm.form.orders,
                                    createAble: true,
                                    showProductImage: true,
                                    selectedWhIdFrom:
                                      _vm.form.pickedWarehouseIdFrom,
                                    selectedWhIdTo:
                                      _vm.form.pickedWarehouseIdTo,
                                    pickedBinIdFrom: _vm.form.pickedBinIdFrom,
                                    pickedBinIdTo: _vm.form.pickedBinIdTo
                                  },
                                  on: { submit: _vm.onSubmitOrder }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("section", [
                        _c("div", { staticClass: "col-md-12 no-padding" }, [
                          _c("div", { staticClass: "form-row" }, [
                            _c("div", { staticClass: "col-md-12" }, [
                              _c("div", { staticClass: "form-group row" }, [
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("placeholder.note")))
                                  ]),
                                  _vm._v(" "),
                                  _c("textarea", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.form.note,
                                        expression: "form.note"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      placeholder: _vm.$t("placeholder.dotted")
                                    },
                                    domProps: { value: _vm.form.note },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.form,
                                          "note",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("section", { staticClass: "action-bar" }, [
                        !_vm.$store.state.app.loading
                          ? _c("div", { staticClass: "col-md-12 text-right" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-web",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      _vm.form.trickValidation++
                                      _vm.isCreateAnother = false
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("button.save")))]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$store.state.app.loading
                          ? _c("div", { staticClass: "col-md-12 text-right" }, [
                              _vm._m(0)
                            ])
                          : _vm._e()
                      ])
                    ]
                  : _vm._e()
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("BaseConfirmDiscardModal", {
        attrs: { show: _vm.confirmDiscardModal.show },
        on: {
          onCancel: _vm.handleDiscardCancleModal,
          onConfirm: _vm.handleDiscardConfirmModal
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn btn-web", attrs: { type: "button", disabled: "" } },
      [_c("i", { staticClass: "fas fa-spinner spin" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c7a46b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c7a46b2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/inventory/goodstransfer/New.vue
// module id = null
// module chunks = 